const gearTagLineComponent = {
  key: 'gearTagLineComponent',
  name: 'Gear Tag Line Component',

  gearTagAlt: `Gear The Way You'd Design It`,
};

exports.gearTagLineComponent = gearTagLineComponent;
